import { Component, OnInit } from '@angular/core';
import { StepService } from '../services/step.service';
import { StartupService } from '../services/startup.service';
import { ConfigurationService } from '../services/configuration.service';
import { skip, take } from 'rxjs/operators';
import { ThreeDService } from '../services/three-d.service';
import { ErrorService } from '../services/error.service';
import { ErrorTypes } from '../enums/errorTypes.enum';

@Component({
  selector: 'app-summary-container',
  templateUrl: './summary-container.component.html',
  styleUrls: ['./summary-container.component.scss'],
})
export class SummaryContainerComponent implements OnInit {
  pricesVisible: boolean;
  screenshotsMade = false;
  loading = true;
  errorState = false;

  constructor(
    private stepService: StepService,
    private startupService: StartupService,
    private threeDService: ThreeDService,
    private errorService: ErrorService,
    private configurationService: ConfigurationService
  ) {}

  ngOnInit() {
    this.errorService.errorMessage$.pipe(skip(1)).subscribe(() => this.stepService.moveToStep(1));
    this.threeDService
      .createAllScreenshots()
      .then(() => {
        this.screenshotsMade = true;
      })
      .catch(() => this.errorService.throwError(ErrorTypes.Generic, 'Unable to make screenshots'));
    this.startupService.priceEnabledSetting$.subscribe((enabled: boolean) => {
      this.pricesVisible = enabled;
      if (!enabled) {
        this.loading = false;
      }
    });
    this.configurationService.configurationSaved$.pipe(take(1)).subscribe(
      () => {
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
    this.configurationService.saveConfiguration(this.configurationService.configuration, false);
  }

  gotoPreviousStep() {
    this.stepService.previousStep();
  }
}
